import React, { useEffect, useState } from 'react';
import { Trans } from '@ecg-marktplaats/js-react-i18n';

import getFeedItems from '../../repositories/getFeedItems';
import FeedItemList from './FeedItemList';
import { trackGAEvent } from '../../../../utils/gaTracking';

import Classes from './Feed.module.scss';

import { TFeedItem } from 'types/TFeeds';
import { TListingClient } from 'types/TListing';

type TFeedsProps = {
  itemId: TListingClient['itemId'];
  isCarAd: TListingClient['isCarAd'];
};

const Feeds = ({ itemId, isCarAd }: TFeedsProps) => {
  const [items, setItems] = useState<TFeedItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchFeedItems = async (): Promise<void> => {
    setIsLoading(true);

    const feedItems = await getFeedItems({ itemId });

    if (feedItems?.length) {
      setItems(feedItems);
    }

    trackGAEvent('InViewport', 'CarsRecommender');

    setIsLoading(false);
  };

  // fetch items when component intersect document's viewport
  useEffect(() => {
    const element = document.querySelector(`.${Classes.root}`);

    if (element) {
      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0]?.intersectionRatio > 0) {
          fetchFeedItems();

          intersectionObserver.unobserve(element);
        }
      });

      intersectionObserver.observe(element);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!items.length && !isLoading) {
    return null;
  }

  return (
    <div className={`${Classes.root} hz-Page-section hz-Page-section--separated`}>
      <Trans i18nKey={isCarAd ? 'feed.cars.title' : 'feed.services.title'} tagName="h3" className={Classes.title} />
      <FeedItemList items={items} isLoading={isLoading} />
    </div>
  );
};

export default Feeds;
